import React from 'react';
import styles from './SectionHeader.module.css';

export default function SectionHeader({ num, title, id }) {
  return (
    <div id={id} className={`${styles.header} fade-in`}>
      <span className={styles.num}>{num}</span>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.line} />
    </div>
  );
}
